// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.error-message {
  font-size: 0.9rem;
  color: #b00020;
}
.error-message p {
  text-align: left;
  margin-bottom: 10px;
  font-style: italic;
}
.error-message ul {
  padding-left: 20px;
  margin: 0;
  text-align: left;
}
.error-message ul li {
  color: red;
}
.error-message ul li.valid {
  color: green;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
  margin-top: -10%;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 5px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type=email] {
  margin-bottom: -1px;
  border-radius: 5px;
}
.form-signin input[type=password] {
  margin-bottom: 10px;
  border-radius: 5px;
}
.form-signin .login-labels {
  width: 100%;
  text-align: left;
}

.login-labels {
  color: var(--undp-jtf-btn-dark-color);
  font-size: 12px;
  font-weight: bold;
}

.input-icon-right {
  position: absolute;
  top: 32px;
  right: 8px;
  z-index: 3;
}

.pe-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
}
.pe-modal-overlay.active {
  opacity: 1;
  visibility: visible;
}

.pe-modal-container {
  background-color: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.pe-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  text-align: center;
}
.pe-modal-header label {
  color: #1a1a1a;
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
  text-align: center;
}
.pe-modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  color: #333;
}
.pe-modal-header .close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
}
.pe-modal-header .close-button:hover {
  color: #333;
}

.pe-modal-head {
  padding: 5px;
  text-align: center;
}
.pe-modal-head label {
  font-size: 15px;
  line-height: 1.5;
  color: #002f6c;
  margin-bottom: 50px;
  max-width: 350px;
  margin-left: auto;
  margin-right: auto;
}
.pe-modal-head h2 {
  font-size: 23px;
}

.pe-modal-footer {
  padding: 10px;
  text-align: center;
}
.pe-modal-footer .pe-actions {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.pe-modal-footer .pe-actions button {
  flex: 1;
  padding: 5px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.pe-modal-footer .pe-actions button.cancel-button {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
}
.pe-modal-footer .pe-actions button.cancel-button:hover {
  background-color: #e5e5e5;
}
.pe-modal-footer .pe-actions button.verify-button {
  background-color: #002f6c;
  color: white;
  border: none;
}
.pe-modal-footer .pe-actions button.verify-button:hover {
  background-color: #002f6c;
}
.pe-modal-footer .pe-actions button.verify-button:disabled {
  background-color: #4e769b;
  cursor: not-allowed;
}

.pe-modal-body {
  padding: 0px;
  text-align: center;
}
.pe-modal-body .qr-code-container {
  display: flex;
  justify-content: center;
}
.pe-modal-body .qr-code-container .qr-code-image {
  max-width: 200px;
  height: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.pe-modal-body .pe-instructions {
  text-align: center;
  margin-bottom: 20px;
  color: #555;
  font-size: 0.95rem;
}
.pe-modal-body .pe-code-inputs {
  display: flex;
  justify-content: center;
  gap: 8px;
}
.pe-modal-body .pe-code-inputs input {
  width: 40px;
  height: 48px;
  text-align: center;
  font-size: 1.25rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.pe-modal-body .pe-code-inputs input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}
.pe-modal-body .error-message {
  color: #e53935;
  text-align: center;
  margin-bottom: 16px;
  font-size: 0.875rem;
}
.pe-modal-body .pe-actions {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.pe-modal-body .pe-actions button {
  flex: 1;
  padding: 12px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.pe-modal-body .pe-actions button.cancel-button {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
}
.pe-modal-body .pe-actions button.cancel-button:hover {
  background-color: #e5e5e5;
}
.pe-modal-body .pe-actions button.verify-button {
  background-color: #002f6c;
  color: white;
  border: none;
}
.pe-modal-body .pe-actions button.verify-button:hover {
  background-color: #002f6c;
}
.pe-modal-body .pe-actions button.verify-button:disabled {
  background-color: #4e769b;
  cursor: not-allowed;
}

/* Contenedor principal del modal */
.modal-container {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  text-align: center;
  font-family: "Arial", sans-serif;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

h2 {
  color: #002f6c;
  font-weight: 700;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

p {
  color: #1a1a1a;
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.qr-code {
  margin: 0 auto 1.5rem;
  width: 150px;
  height: 150px;
}

.label {
  font-weight: bold;
  font-size: 0.95rem;
  margin-bottom: 0.8rem;
}

.otp-fields {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 1.8rem;
  flex-wrap: wrap;
}

.otp-input {
  width: 38px;
  height: 38px;
  font-size: 18px;
  text-align: center;
  border: 2px solid #002f6c;
  border-radius: 6px;
}

.actions {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.btn-cancel,
.btn-verify {
  flex: 1 1 45%;
  padding: 10px 0;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
}

.btn-cancel {
  background: #e0e0e0;
  color: #333;
}

.btn-verify {
  background: #002f6c;
  color: white;
}

/* 📱 Responsivo para móviles */
@media (max-width: 480px) {
  .otp-input {
    width: 36px;
    height: 48px;
    font-size: 20px;
  }
  .modal-container {
    padding: 1.5rem 1rem;
  }
  .btn-cancel, .btn-verify {
    flex: 1 1 100%;
  }
  .qr-code {
    width: 120px;
    height: 120px;
  }
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/password-expired/password-expired-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,iBAAA;EACA,cAAA;AAEF;AAAE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;AACE;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;AACJ;AACI;EACE,UAAA;AACN;AAAM;EACE,YAAA;AAER;;AAIA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AADF;AAEE;EACE,gBAAA;AAAJ;AAEE;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAAJ;AACI;EACE,UAAA;AACN;AAEE;EACE,mBAAA;EACA,kBAAA;AAAJ;AAEE;EACE,mBAAA;EACA,kBAAA;AAAJ;AAEE;EACE,WAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,qCAAA;EACA,eAAA;EACA,iBAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AADF;;AAIA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,yCAAA;AADJ;AAGI;EACE,UAAA;EACA,mBAAA;AADN;;AAKE;EACE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,yCAAA;EACA,gBAAA;AAFJ;;AAKE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AAFJ;AAII;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAFN;AAKI;EACE,SAAA;EACA,kBAAA;EACA,WAAA;AAHN;AAMI;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;AAJN;AAMM;EACE,WAAA;AAJR;;AASE;EACE,YAAA;EACA,kBAAA;AANJ;AAQI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AANN;AASI;EACE,eAAA;AAPN;;AAWE;EACE,aAAA;EACA,kBAAA;AARJ;AASI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAPN;AASM;EACE,OAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAPR;AASQ;EACE,yBAAA;EACA,WAAA;EACA,sBAAA;AAPV;AASU;EACE,yBAAA;AAPZ;AAWQ;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AATV;AAWU;EACE,yBAAA;AATZ;AAYU;EACE,yBAAA;EACA,mBAAA;AAVZ;;AAgBE;EACE,YAAA;EACA,kBAAA;AAbJ;AAeI;EACE,aAAA;EACA,uBAAA;AAbN;AAgBM;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAdR;AAkBI;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAhBN;AAmBI;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AAjBN;AAmBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AAjBR;AAmBQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAjBV;AAsBI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AApBN;AAuBI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AArBN;AAuBM;EACE,OAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AArBR;AAuBQ;EACE,yBAAA;EACA,WAAA;EACA,sBAAA;AArBV;AAuBU;EACE,yBAAA;AArBZ;AAyBQ;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AAvBV;AAyBU;EACE,yBAAA;AAvBZ;AA0BU;EACE,yBAAA;EACA,mBAAA;AAxBZ;;AA+BE,mCAAA;AACF;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,yCAAA;AA5BF;;AA+BA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AA5BF;;AA+BA;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AA5BF;;AA+BA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;AA5BF;;AA+BA;EACE,iBAAA;EACA,kBAAA;EACA,qBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,eAAA;AA5BF;;AA+BA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AA5BF;;AA+BA;;EAEE,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA5BF;;AA+BA;EACE,mBAAA;EACA,WAAA;AA5BF;;AA+BA;EACE,mBAAA;EACA,YAAA;AA5BF;;AA+BA,+BAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;IACA,eAAA;EA5BF;EA+BA;IACE,oBAAA;EA7BF;EAgCA;IACE,cAAA;EA9BF;EAiCA;IACE,YAAA;IACA,aAAA;EA/BF;AACF","sourcesContent":[".error-message {\n  font-size: 0.9rem;\n  color: #b00020;\n\n  p{\n    text-align: left;\n    margin-bottom: 10px;\n    font-style: italic;\n  }\n\n  ul {\n    padding-left: 20px;\n    margin: 0;\n    text-align: left;\n\n    li {\n      color: red;\n      &.valid {\n        color: green;\n      }\n    }\n  }\n}\n\n.form-signin {\n  width: 100%;\n  max-width: 330px;\n  padding: 15px;\n  margin: auto;\n  margin-top: -10%;\n  .checkbox {\n    font-weight: 400;\n  }\n  .form-control {\n    position: relative;\n    box-sizing: border-box;\n    height: auto;\n    padding: 5px;\n    font-size: 16px;\n    &:focus {\n      z-index: 2;\n    }\n  }\n  input[type='email'] {\n    margin-bottom: -1px;\n    border-radius: 5px;\n  }\n  input[type='password'] {\n    margin-bottom: 10px;\n    border-radius: 5px;\n  }\n  .login-labels {\n    width: 100%;\n    text-align: left;\n  }\n}\n\n.login-labels {\n  color: var(--undp-jtf-btn-dark-color);\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.input-icon-right {\n  position: absolute;\n  top: 32px;\n  right: 8px;\n  z-index: 3;\n}\n\n.pe-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1100;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s, visibility 0.3s;\n  \n    &.active {\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n  \n  .pe-modal-container {\n    background-color: #fff;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 500px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n    overflow: hidden;\n  }\n  \n  .pe-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 20px;\n    border-bottom: 1px solid #eee;\n    text-align: center;\n\n    label {\n      color: #1a1a1a;\n      font-size: 0.95rem;\n      margin-bottom: 1.5rem;\n      text-align: center;\n    }\n  \n    h2 {\n      margin: 0;\n      font-size: 1.25rem;\n      color: #333;\n    }\n  \n    .close-button {\n      background: none;\n      border: none;\n      font-size: 1.5rem;\n      cursor: pointer;\n      color: #666;\n  \n      &:hover {\n        color: #333;\n      }\n    }\n  }\n  \n  .pe-modal-head {\n    padding: 5px;\n    text-align: center;\n\n    label {\n      font-size: 15px;\n      line-height: 1.5;\n      color: #002f6c;\n      margin-bottom: 50px;\n      max-width: 350px;\n      margin-left: auto;\n      margin-right: auto;\n    }\n\n    h2{\n      font-size: 23px;\n    }\n  }\n\n  .pe-modal-footer {\n    padding: 10px;\n    text-align: center;\n    .pe-actions {\n      display: flex;\n      justify-content: space-between;\n      gap: 16px;\n  \n      button {\n        flex: 1;\n        padding: 5px;\n        border-radius: 4px;\n        font-size: 1rem;\n        cursor: pointer;\n        transition: background-color 0.2s;\n  \n        &.cancel-button {\n          background-color: #f5f5f5;\n          color: #333;\n          border: 1px solid #ddd;\n  \n          &:hover {\n            background-color: #e5e5e5;\n          }\n        }\n  \n        &.verify-button {\n          background-color: #002f6c;\n          color: white;\n          border: none;\n  \n          &:hover {\n            background-color: #002f6c;\n          }\n  \n          &:disabled {\n            background-color: #4e769b;\n            cursor: not-allowed;\n          }\n        }\n      }\n    }\n  }\n  .pe-modal-body {\n    padding: 0px;\n    text-align: center;\n  \n    .qr-code-container {\n      display: flex;\n      justify-content: center;\n      \n  \n      .qr-code-image {\n        max-width: 200px;\n        height: auto;\n        border: 1px solid #ddd;\n        border-radius: 4px;\n      }\n    }\n  \n    .pe-instructions {\n      text-align: center;\n      margin-bottom: 20px;\n      color: #555;\n      font-size: 0.95rem;\n    }\n  \n    .pe-code-inputs {\n      display: flex;\n      justify-content: center;\n      gap: 8px; \n  \n      input {\n        width: 40px;\n        height: 48px;\n        text-align: center;\n        font-size: 1.25rem;\n        border: 1px solid #ddd;\n        border-radius: 4px;\n  \n        &:focus {\n          outline: none;\n          border-color: #4a90e2;\n          box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);\n        }\n      }\n    }\n  \n    .error-message {\n      color: #e53935;\n      text-align: center;\n      margin-bottom: 16px;\n      font-size: 0.875rem;\n    }\n  \n    .pe-actions {\n      display: flex;\n      justify-content: space-between;\n      gap: 16px;\n  \n      button {\n        flex: 1;\n        padding: 12px;\n        border-radius: 4px;\n        font-size: 1rem;\n        cursor: pointer;\n        transition: background-color 0.2s;\n  \n        &.cancel-button {\n          background-color: #f5f5f5;\n          color: #333;\n          border: 1px solid #ddd;\n  \n          &:hover {\n            background-color: #e5e5e5;\n          }\n        }\n  \n        &.verify-button {\n          background-color: #002f6c;\n          color: white;\n          border: none;\n  \n          &:hover {\n            background-color: #002f6c;\n          }\n  \n          &:disabled {\n            background-color: #4e769b;\n            cursor: not-allowed;\n          }\n        }\n      }\n    }\n  }\n\n  /* Contenedor principal del modal */\n.modal-container {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n  font-family: 'Arial', sans-serif;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\nh2 {\n  color: #002f6c;\n  font-weight: 700;\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n}\n\np {\n  color: #1a1a1a;\n  font-size: 0.95rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.qr-code {\n  margin: 0 auto 1.5rem;\n  width: 150px;\n  height: 150px;\n}\n\n.label {\n  font-weight: bold;\n  font-size: 0.95rem;\n  margin-bottom: 0.8rem;\n}\n\n.otp-fields {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 1.8rem;\n  flex-wrap: wrap;\n}\n\n.otp-input {\n  width: 38px;\n  height: 38px;\n  font-size: 18px;\n  text-align: center;\n  border: 2px solid #002f6c; \n  border-radius: 6px;\n}\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.btn-cancel,\n.btn-verify {\n  flex: 1 1 45%;\n  padding: 10px 0;\n  border: none;\n  border-radius: 6px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.btn-cancel {\n  background: #e0e0e0;\n  color: #333;\n}\n\n.btn-verify {\n  background: #002f6c;\n  color: white;\n}\n\n/* 📱 Responsivo para móviles */\n@media (max-width: 480px) {\n  .otp-input {\n    width: 36px;\n    height: 48px;\n    font-size: 20px;\n  }\n\n  .modal-container {\n    padding: 1.5rem 1rem;\n  }\n\n  .btn-cancel, .btn-verify {\n    flex: 1 1 100%;\n  }\n\n  .qr-code {\n    width: 120px;\n    height: 120px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
